

// get the content to be displayed on welcomePage
export const welcomePageContent = (state) => {
    return state?.welcomePage?.content ? state?.welcomePage?.content : {}
}